export default [
  {
    id: "fashion",
    label: "Fashion",
  },
  {
    id: "home",
    label: "Home",
  },
  {
    id: "automotive",
    label: "Automotive",
  },
  {
    id: "electronics",
    label: "Electronics",
  },
  {
    id: "beauty",
    label: "Beauty",
  },
  {
    id: "groceries",
    label: "Groceries",
  },
  {
    id: "pharmacy",
    label: "Pharmacy",
  },
  {
    id: "restaurants",
    label: "Restaurants",
  },
  {
    id: "gifts",
    label: "Gifts",
  },
  {
    id: "books",
    label: "Books & Music",
  },
  {
    id: "tutoring",
    label: "Tutoring",
  },
  {
    id: "lifestyle",
    label: "Lifestyle",
  },
  {
    id: "travel",
    label: "Travel",
  },
  {
    id: "pets",
    label: "Pets",
  },
  {
    id: "other",
    label: "Other",
  },
];
